import React, { useState } from 'react';
import { Button, useDataProvider, useRefresh, useMutation, useNotify } from 'react-admin';
import { Button as MuiButton, useMediaQuery } from '@material-ui/core';
import ApprovalConfirmDialog from '../dialogs/ApprovalConfirmDialog';
import CheckIcon from '@material-ui/icons/Check';
import { connect } from 'react-redux';
import {payrollApproveAction} from "../../actions/payrollActions";

const ApproveButton = (props) => {
    const [showDialog, setShowDialog] = useState(false);
    const {onApprove, record,redirect,id, loading} = props
    const refresh = useRefresh();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));

    const handleApprove = () => {
        onApprove(record.id, record, redirect);
        setShowDialog(false);
        refresh();
    };

    return (
        <>
            {isSmall ? (
                <MuiButton
                    variant="contained"
                    size="small"
                    color="primary"
                    startIcon={<CheckIcon />}
                    disabled={loading||(record.site||record.employmentType)}
                    onClick={() => setShowDialog(true)}
                >
                    Approve
                </MuiButton>
            ) : (
                <Button
                    label="Approve"
                    onClick={() => setShowDialog(true)}
                    disabled={loading||(record.site||record.employmentType)}
                >
                    <CheckIcon />
                </Button>
            )}
            <ApprovalConfirmDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onApprove={handleApprove}
                payrollRun={record}
            />
        </>
    );
};


 export default connect(state=>({loading:state.admin.loading}),dispatch=>({onApprove:(id,payrollRun,path)=>dispatch(payrollApproveAction(id,payrollRun,path))}))(ApproveButton)